module.exports = __webpack_public_path__ + "img/scrumalliance-ch-pix.36d966b9.jpg";